import { useState } from "react";
import CartProvider from "./store/CartProvider";

import Header from "./components/Layout/Header";
import Meals from "./components/Meals/Meals";
import Cart from './components/Cart/Cart';

function App() {
  const  [cartItemShown, setCartItemShown] = useState(false)

  const showCartHandler = () => {
    setCartItemShown(true)
  }

  const hideCartHandler = () => {
    setCartItemShown(false)
  }


  return (
    <CartProvider>
      {cartItemShown && <Cart onHideCart={hideCartHandler} />}
      <Header onShowCart={showCartHandler} />
      <main>
        <Meals />
      </main>
    </CartProvider>
  );
}

export default App;
